export default __webpack_public_path__ + "static/media/main_saying03_jp.89343177.png";